/**
 * BackendBackupTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {BackendBackupExport} from "./BackendBackupExport";
import {BackendBackupImport} from "./BackendBackupImport";
import {BackendBackupImportResult} from "./BackendBackupImportResult";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendBackupTag extends TagAbstract {
    /**
     * Generates an backup of the current system
     *
     * @returns {Promise<BackendBackupExport>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async export(): Promise<BackendBackupExport> {
        const url = this.parser.url('/backend/backup/export', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
            },
            params: this.parser.query({
            }, [
            ]),
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendBackupExport;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Imports an backup to the current system
     *
     * @returns {Promise<BackendBackupImportResult>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async import(payload: BackendBackupImport): Promise<BackendBackupImportResult> {
        const url = this.parser.url('/backend/backup/import', {
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as BackendBackupImportResult;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
